import { useContext, useEffect } from "react";
import FNMAuthContext from "../../store/FNMStore/FNM-auth-context";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import useHttpFetch from "../../hooks/useHttpFetch";
import LoadingOverLoadedPage from "../../Components/UI/LoadingOverLoadedPage/LoadingOverLoadedPage";
import { Helmet } from "react-helmet-async";

const IsLoggedInInFNM = () => {
  const { clientAuthInfo, setClientAuthInfo } = useContext(FNMAuthContext);
  const navigate = useNavigate();
  const { sendRequest } = useHttpFetch(false, "FNM");
  const location = useLocation();

  useEffect(() => {
    const getAuthOnLoad = async () => {
      const verifyReqOptions = {
        url: `mlmDataEntry/CheckAccess`,
        noMiddleUrl: true,
        port: "9092"
      };

      const authRes = await sendRequest(verifyReqOptions);
      if (authRes?.resIsOk && authRes?.resStatus == 200) {
        setClientAuthInfo((ps) => ({
          ...ps,
          isLoggedIn: true,
        }));
        navigate(
          `/form-network-marketer`
        );
      } else {
        navigate("/form-network-marketer/login");
      }

      setClientAuthInfo((ps) => ({
        ...ps,
        isLoading: false,
      }));
    };
    getAuthOnLoad();
  }, []);

  return (
    <>
      <Helmet>
        <meta name="description" content="SaleRepresentativesManagement Information" />
        <meta property="og:title" content="Pergas Teb - SaleRepresentativesManagement" />
        <meta property="og:description" content="SaleRepresentativesManagement Information" />
        <meta name="twitter:title" content="Pergas Teb - SaleRepresentativesManagement" />
        <meta name="twitter:description" content="SaleRepresentativesManagement Information" />
        <title>Pergas Teb - NetworkMarketer</title>
      </Helmet>
      {clientAuthInfo.isLoading ? <LoadingOverLoadedPage /> : <Outlet />}
    </>
  );
};

export default IsLoggedInInFNM;
